import { useEffect, useState } from "react";
import api from "@/lib/api";

// anteprima con autenticazione (img non può mandare header)
export default function AuthImg({ src, alt = "", className = "" }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u = null, alive = true;
    api.get(src, { responseType: "blob" }).then((r) => {
      if (!alive) return;
      u = URL.createObjectURL(r.data);
      setUrl(u);
    }).catch(() => {});
    return () => { alive = false; if (u) URL.revokeObjectURL(u); };
  }, [src]);
  return url ? <img src={url} alt={alt} className={className} /> : <div className={`${className} bg-slate-100 animate-pulse`} />;
}
